import camelcaseKeys from 'camelcase-keys';

const discoveryPath = '/oidc/.well-known/openid-configuration';
const fetchOidcConfig = async (endpoint, requester) => camelcaseKeys(await requester(endpoint));

export { discoveryPath, fetchOidcConfig };
